/* eslint-disable @typescript-eslint/naming-convention */
// constants and types
export const SET_USER = "SET_USER";
type SET_USER = typeof SET_USER;

export const SET_AUTH_STATE = "SET_AUTH_STATE";
type SET_AUTH_STATE = typeof SET_AUTH_STATE;
